import { Button, Card, Icon } from '@zillow/constellation-10';
import { IconHomesFilled, IconSearchFilled } from '@zillow/constellation-icons';

import EmptyState from '../../../components/EmptyState';

type Props = {
  // Absent when the archived filter alone produced no results.
  searchText?: string;
  onClear: () => void;
};

export const FlexiblePropertyNoResultsEmptyState = ({ searchText, onClear }: Props) => {
  const copy = searchText
    ? {
        icon: <IconSearchFilled />,
        heading: 'No properties found',
        body: `No properties match “${searchText}”. Try adjusting your search.`,
        action: 'Clear search',
      }
    : {
        icon: <IconHomesFilled />,
        heading: 'No archived properties',
        body: 'Properties you archive will show up here.',
        action: 'Clear filter',
      };

  return (
    <Card
      tone="neutral"
      elevated={false}
      css={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        paddingInline: '400',
        paddingBlock: '400',
        width: '100%',
        minHeight: { xxl: '464px' },
      }}
    >
      <EmptyState
        useCard={false}
        align="center"
        data-testid="FlexiblePropertyNoResultsEmptyState"
        icon={<Icon render={copy.icon} size="md" css={{ color: 'icon.subtle' }} />}
        heading={copy.heading}
        headingLevel={3}
        body={copy.body}
        actions={
          <Button
            tone="brand"
            emphasis="outlined"
            onClick={onClear}
            data-testid="FlexiblePropertyNoResultsEmptyStateClearButton"
          >
            {copy.action}
          </Button>
        }
      />
    </Card>
  );
};
